export default function SpotifyComponent({ meta }) {
  function spotify_parser(url) {
    var result = -1;
    if (url.indexOf("/album/") != -1) result = url.indexOf("/album/");
    if (url.indexOf("/playlist/") != -1) result = url.indexOf("/playlist/");
    if (url.indexOf("/track/") != -1) result = url.indexOf("/track/");
    if (url.indexOf("/artist/") != -1) result = url.indexOf("/artist/");

    let id = url.substring(result);
    return id;
  }
  var id = spotify_parser(meta.url);
  var r =
    '<iframe style="border-radius:12px" src="https://open.spotify.com/embed' +
    id +
    '" width="100%" height="380" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>';
  //  var r = `<iframe class="yt-video"  src="https://www.youtube.com/embed/${id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

  return (
    <div
      style={{ marginTop: "5px" }}
      dangerouslySetInnerHTML={{
        __html: r,
      }}
    />
  );
}
